import { render } from "./SalvusHealth.vue?vue&type=template&id=1886c759&scoped=true&ts=true"
import script from "./SalvusHealth.vue?vue&type=script&lang=ts"
export * from "./SalvusHealth.vue?vue&type=script&lang=ts"

import "./SalvusHealth.vue?vue&type=style&index=0&id=1886c759&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1886c759"]])

export default __exports__